import { useMelwaysInfo } from '@seek/melways-react';
import {
  type NavigateOptions,
  useNavigate,
  useSearchParams,
} from 'react-router-dom';

import {
  generateNavigateTo,
  type RouteParams,
} from 'src/components/Router/generateNavigateTo';
import { usePage } from 'src/components/Router/usePage';

export const useNavigateRoute = () => {
  const navigate = useNavigate();
  const page = usePage();
  const [params] = useSearchParams();
  const { language } = useMelwaysInfo();

  return (routeParams: RouteParams, routeOptions: NavigateOptions = {}) => {
    // Extract & preserve only "features=" and full "v=branch-${BUILDKITE_BRANCH}" search params
    const preservedParams = new URLSearchParams();
    if (params.has('features')) {
      preservedParams.set('features', params.get('features')!);
    }

    const vParam = params.get('v');
    if (vParam && vParam.startsWith('branch')) {
      preservedParams.set('v', vParam);
    }

    const mergedParams = new URLSearchParams(routeParams.params || {});
    preservedParams.forEach((value, key) => mergedParams.set(key, value));

    navigate(
      generateNavigateTo({
        ...routeParams,
        lang: language === 'en' ? undefined : language,
        page: routeParams.page || page,
        params: Object.fromEntries(mergedParams),
      }),
      routeOptions,
    );
  };
};
